import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "./light.css";
import { BrowserRouter } from "react-router";
import App from "./App.tsx";
import { AppProvider } from "./adapters/app/AppProvider.tsx";

import { FeatureFlagProvider } from "./config/FeatureFlagManager/FeatureFlagProvider.tsx";
const colorSchemeQuery = window.matchMedia("(prefers-color-scheme: dark)");
if (colorSchemeQuery.matches) {
  document.documentElement.setAttribute("data-theme", "dark");
} else {
  document.documentElement.setAttribute("data-theme", "light");
}
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <FeatureFlagProvider>
        <AppProvider>
          <App />
        </AppProvider>
      </FeatureFlagProvider>
    </BrowserRouter>
  </StrictMode>,
);
